// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./core/vue/css/compare.css
// module id = 874
// module chunks = 36